<div class="iv-page">

  <!-- Mobile header -->
  <app-mobile-page-header
    [title]="isMinisterOrOsd() ? 'Recurring Intervention' : 'Intervention Hub'"
    [showAvatar]="false"
    (back)="goBack()"
    class="-mx-4 -mt-4 block md:hidden" />

  <!-- ══ DARK HERO HEADER (desktop) ══════════════════════════════ -->
  <div class="iv-head">
    <div class="iv-head-inner">

      <div class="iv-head-left">
        <button (click)="goBack()" class="iv-bc-btn" style="margin-bottom:10px;">
          <i class="fa-solid fa-arrow-left"></i> Back to Dashboard
        </button>
        <h1 class="iv-title">
          <span class="iv-title-icon"><i class="fa-solid fa-rotate"></i></span>
          {{ isMinisterOrOsd() ? 'Recurring Intervention' : 'Intervention Hub' }}
        </h1>
        <p class="iv-sub">Projects flagged for follow-up, high visibility, or delayed execution</p>
      </div>

      <div class="iv-head-stats">
        <div class="iv-hst">
          <span class="iv-hst-num">{{ ivStats().total }}</span>
          <span class="iv-hst-lbl">Total Projects</span>
        </div>
        <div class="iv-hst-div"></div>
        <div class="iv-hst">
          <span class="iv-hst-num">{{ ivStats().stuckCount }}</span>
          <span class="iv-hst-lbl">Stuck</span>
        </div>
        <div class="iv-hst-div"></div>
        <div class="iv-hst">
          <span class="iv-hst-num">{{ ivStats().avgProgress }}%</span>
          <span class="iv-hst-lbl">Avg Progress</span>
        </div>
      </div>

    </div>
  </div>

  <!-- ══ FILTER TABS (non-minister / non-OSD only) ═══════════════ -->
  @if (!isMinisterOrOsd()) {
    <div class="iv-filter-tabs">
      @for (filter of filters; track filter.key) {
        <button
          [class]="'iv-tab' + (activeFilter() === filter.key ? ' iv-tab-act' : '')"
          (click)="setFilter(filter.key)">
          <i [class]="filter.icon"></i>
          {{ filter.label }}
        </button>
      }
    </div>
  }

  <!-- ══ TOOLBAR ══════════════════════════════════════════════════ -->
  <div class="iv-toolbar">

    <div class="iv-search-box">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input
        class="iv-search-inp"
        type="text"
        placeholder="Search project, dept, location…"
        [value]="searchQuery()"
        (input)="searchQuery.set($any($event.target).value); currentPage.set(1)" />
      @if (searchQuery()) {
        <button class="iv-search-clear" (click)="clearSearch()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      }
    </div>

    @if (selectedIds().size > 0) {
      <div class="iv-bulk-bar">
        <span class="iv-bulk-info">
          <i class="fa-solid fa-circle-check"></i>
          {{ selectedIds().size }} selected
        </span>
        <button class="iv-bulk-cancel" (click)="clearSelection()" type="button">
          <i class="fa-solid fa-xmark"></i>
        </button>
        <button class="iv-bulk-del" (click)="showBulkDeleteConfirm.set(true)" type="button">
          <i class="fa-solid fa-trash-can"></i> Delete
        </button>
      </div>
    }

    <div class="iv-view-toggle">
      <button [class.iv-vt-active]="!cardView()" (click)="cardView.set(false)">
        <i class="fa-solid fa-table-list"></i> Table
      </button>
      <button [class.iv-vt-active]="cardView()" (click)="cardView.set(true)">
        <i class="fa-solid fa-grip"></i> Cards
      </button>
    </div>

  </div>

  <!-- ══ RESULTS BAR ══════════════════════════════════════════════ -->
  <div class="iv-results-bar">
    <span>
      Showing <strong>{{ pageStart() }}–{{ pageEnd() }}</strong>
      of <strong>{{ searchedProjects().length }}</strong> projects
      <span class="iv-filt-chip">{{ activeConfig().label }}</span>
    </span>
  </div>

  <!-- ══ EMPTY STATE ══════════════════════════════════════════════ -->
  @if (searchedProjects().length === 0) {
    <div class="iv-empty">
      <i class="fa-solid fa-circle-check"></i>
      <p>No projects in this category</p>
      <p class="iv-empty-sub">All projects are on track</p>
    </div>
  }

  <!-- ══ CARD GRID ════════════════════════════════════════════════ -->
  @if (cardView() && searchedProjects().length > 0) {
    <div class="iv-grid">
      @for (p of paginatedProjects(); track p.id; let i = $index) {

        <div class="iv-card" [class.iv-card-selected]="selectedIds().has(p.id)">

          <div class="iv-card-hdr">
            <div class="iv-card-chk" (click)="$event.stopPropagation()">
              <input type="checkbox"
                [checked]="selectedIds().has(p.id)"
                (change)="toggleSelect(p.id)"
                [attr.aria-label]="'Select ' + p.name" />
            </div>
            <div class="iv-dept-ico" [style.background]="getDeptColor(p.dept)">
              {{ getDeptAbbr(p.dept) }}
            </div>
            <div class="iv-card-title-block">
              <div class="iv-card-name">{{ p.name }}</div>
              @if (p.scheme) {
                <div class="iv-card-scheme">{{ p.scheme }}</div>
              }
            </div>
            <div class="iv-card-num">{{ pageStart() + i }}</div>
          </div>

          <div class="iv-card-rows" (click)="openProject(p.id)" tabindex="0" (keydown.enter)="openProject(p.id)">
            <div class="iv-data-row">
              <span class="iv-row-lbl"><i class="fa-solid fa-location-dot"></i> Location</span>
              <span class="iv-row-val">{{ p.loc || '—' }}</span>
            </div>
            <div class="iv-data-row">
              <span class="iv-row-lbl"><i class="fa-solid fa-indian-rupee-sign"></i> Cost</span>
              <span class="iv-row-val">{{ fmt(p.cost) }}</span>
            </div>
            <div class="iv-data-row">
              <span class="iv-row-lbl"><i class="fa-solid fa-gauge"></i> Progress</span>
              <span class="iv-row-val iv-prog-pct" [style.color]="getProgressColor(p.physical)">
                {{ p.physical }}%
              </span>
            </div>
          </div>

          <div class="iv-prog-track">
            <div class="iv-prog-fill"
              [style.width.%]="p.physical"
              [style.background]="getProgressColor(p.physical)">
            </div>
          </div>

          <div class="iv-card-foot">
            <div class="iv-foot-chips">
              <span [class]="'iv-chip ' + statusClass(p.status)">{{ p.status }}</span>
              @if (p.hmPriority) {
                <span class="iv-chip iv-chip-hm"><i class="fa-solid fa-crown"></i> HM</span>
              }
              @if (p.recurringIntervention) {
                <span class="iv-chip iv-chip-rec"><i class="fa-solid fa-rotate"></i> Rec</span>
              }
              @if (p.visibility) {
                <span class="iv-chip iv-chip-vis">{{ p.visibility }}</span>
              }
            </div>
            <button class="iv-check-btn" (click)="openProject(p.id)">
              View <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>

        </div>

      }
    </div>
  }

  <!-- ══ TABLE VIEW ═══════════════════════════════════════════════ -->
  @if (!cardView() && searchedProjects().length > 0) {
    <div class="iv-tbl-wrap">
      <table class="iv-table">
        <thead>
          <tr>
            <th style="width:40px">
              <input type="checkbox"
                [checked]="isAllSelected()"
                (change)="toggleSelectAll()"
                aria-label="Select all projects" />
            </th>
            <th style="width:44px">#</th>
            <th>Project Name</th>
            <th>Dept</th>
            <th>Location</th>
            <th>Cost</th>
            <th style="width:140px">Progress</th>
            <th>Status</th>
            <th style="width:80px">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (p of paginatedProjects(); track p.id; let i = $index) {
            <tr [class.iv-row-sel]="selectedIds().has(p.id)">
              <td class="iv-td-c" (click)="$event.stopPropagation()">
                <input type="checkbox"
                  [checked]="selectedIds().has(p.id)"
                  (change)="toggleSelect(p.id)"
                  [attr.aria-label]="'Select ' + p.name" />
              </td>
              <td class="iv-td-c">{{ pageStart() + i }}</td>
              <td class="iv-td-name">
                <div class="iv-tbl-pname">{{ p.name }}</div>
                @if (p.visibility) {
                  <span class="iv-chip iv-chip-vis" style="font-size:9px;padding:1px 6px">{{ p.visibility }}</span>
                }
              </td>
              <td>
                <div class="iv-tbl-dept-cell">
                  <span class="iv-tbl-dept-ico" [style.background]="getDeptColor(p.dept)">
                    {{ getDeptAbbr(p.dept) }}
                  </span>
                  {{ p.dept }}
                </div>
              </td>
              <td class="iv-td-sm">{{ p.loc }}</td>
              <td class="iv-td-c">{{ fmt(p.cost) }}</td>
              <td>
                <div class="iv-tbl-prog">
                  <div class="iv-prog-track iv-prog-sm">
                    <div class="iv-prog-fill"
                      [style.width.%]="p.physical"
                      [style.background]="getProgressColor(p.physical)">
                    </div>
                  </div>
                  <span [style.color]="getProgressColor(p.physical)"
                    style="font-size:11px;font-weight:700;white-space:nowrap">
                    {{ p.physical }}%
                  </span>
                </div>
              </td>
              <td>
                <span [class]="'iv-chip ' + statusClass(p.status)">{{ p.status }}</span>
              </td>
              <td>
                <button class="iv-tbl-btn" (click)="openProject(p.id)">
                  View <i class="fa-solid fa-arrow-right"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- ══ PAGINATION ═══════════════════════════════════════════════ -->
  @if (searchedProjects().length > pageSize) {
    <div class="iv-pagination">
      <span class="iv-pag-info">
        Showing {{ pageStart() }} to {{ pageEnd() }} of {{ searchedProjects().length }} projects
      </span>
      <div class="iv-pag-btns">
        @for (pg of pages(); track pg) {
          <button [class.iv-pag-act]="currentPage() === pg" (click)="goToPage(pg)">{{ pg }}</button>
        }
      </div>
    </div>
  }

</div>

<!-- ══ BULK DELETE MODAL ══════════════════════════════════════════ -->
@if (showBulkDeleteConfirm()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
    role="dialog" aria-modal="true" aria-labelledby="bulk-del-title">
    <div class="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-sm space-y-4">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
          <i class="fa-solid fa-trash-can text-red-600" aria-hidden="true"></i>
        </div>
        <div>
          <h2 id="bulk-del-title" class="text-base font-bold text-slate-800">Delete Projects</h2>
          <p class="text-sm text-slate-500">This action cannot be undone.</p>
        </div>
      </div>
      <p class="text-sm text-slate-700">
        Are you sure you want to permanently delete
        <strong>{{ selectedIds().size }} project{{ selectedIds().size > 1 ? 's' : '' }}</strong>?
      </p>
      <div class="flex gap-3 pt-1">
        <button (click)="showBulkDeleteConfirm.set(false)"
          class="flex-1 px-4 py-2 rounded-xl border border-slate-200 text-slate-700 text-sm font-medium hover:bg-slate-50 transition"
          type="button" [disabled]="isBulkDeleting()">
          Cancel
        </button>
        <button (click)="bulkDeleteProjects()"
          class="flex-1 px-4 py-2 rounded-xl bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition flex items-center justify-center gap-2"
          type="button" [disabled]="isBulkDeleting()">
          @if (isBulkDeleting()) {
            <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Deleting…
          } @else {
            <i class="fa-solid fa-trash-can" aria-hidden="true"></i> Delete
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- ══ BULK DELETE SUCCESS TOAST ════════════════════════════════ -->
@if (bulkDeleteSuccess()) {
  <div class="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-5 py-3 rounded-xl bg-emerald-600 text-white text-sm font-semibold shadow-lg flex items-center gap-2"
    role="status" aria-live="polite">
    <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
    {{ bulkDeleteSuccess() }}
  </div>
}
